/** @format */
import { User } from '@toucan/common/services/user/types';

import { DataLayerEventType } from '@toucan/client/global/analytics';
import { MarketSlug } from '@toucan/client/global/market';

import { logout } from '@toucan/client/core/user';

import { trackEventsViaDataLayer } from '@toucan/client/shared/helpers/analytics';
import { resetIntercomSession } from '@toucan/client/shared/helpers/intercom';

export async function logoutAndRedirect(marketSlug: MarketSlug, user?: User) {
    resetIntercomSession();

    await logout();

    const dataLayerEvents = [
        {
            event: DataLayerEventType.USER_LOADED,
            userId: null,
            loginStatus: false,
        },
        {
            event: DataLayerEventType.LOGOUT,
            userId: user?.customerId,
        },
    ];

    trackEventsViaDataLayer(dataLayerEvents);

    // NOTE: Deliberately don't use next/router here so that
    // we force a full page load, refreshing the page memory
    // and ensuring we start from a clean slate
    window.location.pathname = `/${marketSlug}`;
}
